import classNames from 'classnames'
import * as React from 'react'

import './InvoiceEditorHeading.scss'

export interface InvoiceEditorHeadingPropsInterface {
  heading: string
  closeAction?: () => void
  isAgerasNextMigration: boolean
}

export class InvoiceEditorHeading extends React.Component<InvoiceEditorHeadingPropsInterface, any> {
  public render() {
    return (
      <div className="Header">
        <div
          className={classNames('navbar', {
            agerasNextMigration: this.props.isAgerasNextMigration,
          })}
        >
          {this.props.closeAction && <div className="closeButton" onClick={this.props.closeAction}></div>}
          <div className="heading">{this.props.heading}</div>
          <div className="buttons">{this.props.children}</div>
        </div>
      </div>
    )
  }
}
